import React from "react";

export default function Footer() {
  return (
    <footer className="footer">
      <h1>Thank You!</h1>
    </footer>
  );
}
